import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useField } from 'formik';
import { HexColorPicker } from 'react-colorful';

interface ColorPickerProps {
    name: string;
    label?: string;
}

const ColorPicker = ({ name, label }: ColorPickerProps) => {
    const theme = useTheme();
    const [{ value: colour }, { error, touched }, { setValue: setColour }] = useField(name);

    const hasError = useMemo(() => {
        return error && touched;
    }, [error, touched]);

    return (
        <Box>
            {label && (
                <Typography
                    color={theme.palette.text.primary}
                    fontWeight={600}
                    fontSize="14px"
                    marginBottom="13px"
                >
                    {label}
                </Typography>
            )}
            <Box display="flex" alignItems="center" gap={2} mt={1}>
                <Box>
                    <HexColorPicker
                        color={colour}
                        onChange={setColour}
                        data-testid="hex-color-picker"
                    />
                </Box>

                <Box>
                    <Box
                        sx={{
                            width: 64,
                            height: 64,
                            backgroundColor: colour,
                            borderRadius: 1,
                            border: '1px solid rgba(0,0,0,0.12)',
                        }}
                    />
                    <Typography variant="body2" mt={1} data-testid="selected-color">
                        {colour}
                    </Typography>
                </Box>
            </Box>

            <Typography variant="caption" display="block" mt={1}>
                This colour will be used as the background colour for email communications
            </Typography>
            {hasError && <label className="error">{error}</label>}
        </Box>
    );
};

export default ColorPicker;
